/* eslint-disable react/prop-types */
import React, { useState, createContext, useEffect } from 'react';
import { useMediaQuery } from '@material-ui/core';
import theme from '../themes/default';

export const ResponsiveContext = createContext({});

export const ResponsiveContextProvider = ({ children }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMedium = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ResponsiveContext.Provider value={{ isMobile, isMedium }}>
      {children}
    </ResponsiveContext.Provider>
  );
};
